export function isStagingDeploy(): boolean {
  return import.meta.env?.VITE_DEPLOY_TARGET === "staging";
}

export function formatStagingPageTitle(title: string): string {
  return isStagingDeploy() ? `${title} - Staging` : title;
}
